import axios from 'axios';

export const getHttpClient = (baseURL: string) => {
  const client = axios.create({
    headers: {
      'content-type': 'application/json',
    },
    baseURL,
  });
  client.interceptors.request.use(
    (config) => {
      //if we change the endpoint in the future we need to update this logic
      // if (config.url?.includes('/v1/generate-access-token')) {
      //   config.headers['content-type'] = 'application/x-www-form-urlencoded';
      //
      // } else if (config.url?.includes('/visitor/submit')) {
      //   config.headers['content-type'] = 'multipart/form-data';
      // }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return client;
};

export const getOutBoundedHttpClient = () =>
  axios.create({
    headers: {
      'content-type': 'application/json',
    },
  });
